import React, { useState, useRef, useEffect } from "react";
import "../../css/CaptchaOtp.css";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginContain, LoginFooter } from "../../style/login/Login";
import Logo from "../../assets/images/logo.png";
import { Loader } from "../../utils/loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MFAConfirmLogin, MFASendOTP } from "../../services/authServices";
import { setRole } from '../../features/RoleSlice';

function CaptchaOtp() {

  const location = useLocation();
  const navigate = useNavigate();

  const { maskedEmail, maskedPhoneNo, password, userId, userType } = location.state || {}

  useEffect(() => {
    if (!maskedEmail || !maskedPhoneNo || !password || !userId || !userType) {
      toast.error("Missing Dependency")
      navigate("/")
      return
    }
  }, [])

  const [currentStep, setCurrentStep] = useState(1);
  const [captcha, setCaptcha] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const otpInputRefs = useRef([]);

  const [loading, setLoading] = useState(false);

  const generateCaptcha = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789abcdefghijkmnopqrst";
    let result = "";
    for (let i = 0; i < 6; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setCaptcha(result);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);


  useEffect(() => {
    if (currentStep === 2 && timer > 0) {
      const countdown = setInterval(() => setTimer((prev) => prev - 1), 1000);
      return () => clearInterval(countdown);
    }
  }, [timer, currentStep]);

  const handleSendOTP = async () => {

    const userCaptcha = captchaInput.trim();
    const actualCaptcha = captcha.trim();

    if (!userCaptcha) {
      setCaptchaError("Please enter the captcha");
      return;
    }

    if (userCaptcha !== actualCaptcha) {
      setCaptchaError("Invalid captcha. Please try again.");
      generateCaptcha();
      setCaptchaInput("");
      return;
    }

    // API CALL SEND OTP
    setLoading(true)

    try {

      const payload = { password, userId, userType }
      const response = await MFASendOTP({ payload })

      setCurrentStep(2);
      setCaptchaError("");
      setTimer(60);
      toast.success(response.message);

      setOtp(["", "", "", "", "", ""]);
      if (otpInputRefs.current[0]) {
        otpInputRefs.current[0].focus();
      }

    } catch (error) {
      toast.error(error?.response?.data?.error ?? "Something went wrong");
    } finally {
      setLoading(false)
    }

    setTimeout(() => {
      if (otpInputRefs.current[0]) {
        otpInputRefs.current[0].focus();
      }
    }, 100);
  };

  const handleOtpChange = (value, index) => {
    if (value && !/^\d$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < otpInputRefs.current.length - 1) {
      otpInputRefs.current[index + 1].focus();
    }
    if (!value && index > 0) {
      otpInputRefs.current[index - 1].focus();
    }
  };

  const handleConfirmLogin = async () => {
    const enteredOtp = otp.join("");

    if (enteredOtp.length !== 6) {
      toast.error("Please enter complete 6-digit OTP");
      return;
    }

    // API CALL CHECK OTP
    setLoading(true)

    try {

      const payload = { password, userId, userType, otp: enteredOtp }

      const response = await MFAConfirmLogin({ payload })
      console.log(response, "--response")
      localStorage.setItem('user_cred', JSON.stringify(response))
      setRole(response.roleType);
      navigate('/home');

    } catch (error) {
      localStorage.clear()
      toast.error(error?.response?.data?.error ?? "Something went wrong");
      setOtp(["", "", "", "", "", ""]);
    } finally {
      setLoading(false)
    }

  };

  const handleBackToCaptcha = () => {
    setCurrentStep(1);
    setOtp(["", "", "", "", "", ""]);
    setCaptchaInput("");
    setCaptchaError("");
    setTimer(60);
    generateCaptcha();
  };

  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      otpInputRefs.current[index - 1].focus();
    }
    if (e.key === "ArrowLeft" && index > 0) {
      otpInputRefs.current[index - 1].focus();
    }
    if (e.key === "ArrowRight" && index < otpInputRefs.current.length - 1) {
      otpInputRefs.current[index + 1].focus();
    }
  };

  const CanvasCaptcha = ({ captcha }) => {
    const canvasRef = useRef(null);
    useEffect(() => {

      const canvas = canvasRef.current;
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "#f5f5f5";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      const fontSize = 28;
      ctx.font = `${fontSize}px Arial`;
      for (let i = 0; i < captcha.length; i++) {
        const x = 20 + i * 22;
        const y = 35 + Math.random() * 5;
        ctx.save();
        ctx.fillStyle = `hsl(${Math.random() * 360}, 80%, 30%)`;
        ctx.translate(x, y);
        ctx.rotate((Math.random() - 0.5) * 0.4);
        ctx.fillText(captcha[i], 0, 0);
        ctx.restore();
      }
      for (let i = 0; i < 4; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
        ctx.strokeStyle = "rgba(0,0,0,0.2)";
        ctx.lineWidth = 1;
        ctx.stroke();
      }
      for (let i = 0; i < 30; i++) {
        ctx.fillStyle = "rgba(0,0,0,0.3)";
        ctx.beginPath();
        ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, 1, 0, Math.PI * 2);
        ctx.fill();
      }
    }, [captcha]);

    return (
      <canvas
        ref={canvasRef}
        width={300}
        height={50}
        style={{ width: "100%", maxWidth: "300px", height: "auto" }}
      ></canvas>
    );
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <LoginContain>
        <div className="LoginLogo">
          <img src={Logo} alt="logo" />
        </div>
        <div className="LoginCard">
          <div className="captcha-otp-step-indicator">
            <div className={`captcha-otp-step ${currentStep >= 1 ? "captcha-otp-step-active" : ""}`}>
              <span className="captcha-otp-step-number">1</span>
              <span className="captcha-otp-step-text">Captcha</span>
            </div>
            <div className="captcha-otp-step-divider"></div>
            <div className={`captcha-otp-step ${currentStep >= 2 ? "captcha-otp-step-active" : ""}`}>
              <span className="captcha-otp-step-number">2</span>
              <span className="captcha-otp-step-text">OTP</span>
            </div>
          </div>
          {currentStep === 1 && (
            <>
              <div className="LoginTitle1">
                <h4>Two Factor Verification</h4>
                <p>Please enter the captcha to proceed</p>
              </div>
              <div className="captcha-otp-contact-info">
                <div className="captcha-otp-contact-item">
                  <span className="captcha-otp-contact-label">Email:</span>
                  <span className="captcha-otp-contact-value">{maskedEmail}</span>
                </div>

                <div className="captcha-otp-contact-item">
                  <span className="captcha-otp-contact-label">Mobile:</span>
                  <span className="captcha-otp-contact-value">{maskedPhoneNo}</span>
                </div>
              </div>
              <form onSubmit={(e) => {
                e.preventDefault();
                handleSendOTP()
              }}>
                <div className="captcha-otp-form-group">
                  <label className="captcha-otp-label">Enter Captcha</label>

                  <div className="captcha-otp-captcha-container">
                    <div className="captcha-otp-captcha-display">
                      <CanvasCaptcha captcha={captcha} />

                      <button
                        type="button"
                        onClick={() => {
                          generateCaptcha();
                          setCaptchaInput("");
                          setCaptchaError("");
                        }}
                        className="captcha-otp-refresh-btn"
                      >
                        ↻
                      </button>
                    </div>
                  </div>

                  <input
                    type="text"
                    value={captchaInput}
                    onChange={(e) => {
                      setCaptchaInput(e.target.value);
                      setCaptchaError("");
                    }}
                    placeholder="Enter captcha"
                    className="captcha-otp-input"
                    maxLength="6"
                    autoComplete="off"
                  />

                  {captchaError && <div className="captcha-otp-error">{captchaError}</div>}
                </div>

                <div className="captcha-otp-btn-group">
                  <button
                    type="submit"
                    className="captcha-otp-submit-btn"
                    disabled={loading || !captchaInput.trim()}
                  >
                    {loading ? <Loader /> : "Verify & Send OTP"}
                  </button>
                </div>
              </form>
            </>
          )}

          {currentStep === 2 && (
            <>
              <div className="LoginTitle1">
                <h4>OTP Verification</h4>
                <p>Enter the OTP sent to your registered details</p>
              </div>

              <div className="captcha-otp-contact-info">
                <div className="captcha-otp-contact-item">
                  <span className="captcha-otp-contact-label">Email:</span>
                  <span className="captcha-otp-contact-value">{maskedEmail}</span>
                </div>

                <div className="captcha-otp-contact-item">
                  <span className="captcha-otp-contact-label">Mobile:</span>
                  <span className="captcha-otp-contact-value">{maskedPhoneNo}</span>
                </div>
              </div>

              <form onSubmit={(e) => {
                e.preventDefault();
                handleConfirmLogin()
              }}>
                <div className="captcha-otp-form-group">
                  <label className="captcha-otp-label">Enter 6-digit OTP</label>
                  <div className="captcha-otp-otp-container">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                        onKeyDown={(e) => handleOtpKeyDown(e, index)}
                        ref={(el) => (otpInputRefs.current[index] = el)}
                        className="captcha-otp-otp-input"
                        autoComplete="off"
                      />
                    ))}
                  </div>
                </div>

                <div className="captcha-otp-timer-container">
                  {timer > 0 ? (
                    <span className="captcha-otp-timer">
                      Time Remaining: <strong>{timer}s</strong>
                    </span>
                  ) : (
                    <button type="button" onClick={handleSendOTP} className="captcha-otp-resend-btn">
                      Resend OTP
                    </button>
                  )}
                </div>

                <div className="captcha-otp-btn-group">
                  <button type="button" onClick={handleBackToCaptcha} className="captcha-otp-back-btn">
                    ← Back
                  </button>
                  <button type="submit" className="captcha-otp-submit-btn" disabled={otp.join("").length !== 6}>
                    Verify OTP
                  </button>
                </div>
              </form>
            </>
          )}
        </div>
      </LoginContain>

      <LoginFooter>
        <p>
          POWERED BY: <span>Manthan IT Solutions</span>
        </p>
      </LoginFooter>
    </>
  );
}

export default CaptchaOtp;
